import React from 'react';

import classNames from 'classnames';

import './styles/search_page.scss';

type Props = {
  children?: React.ReactNode,
  className?: string,
};

export default function SearchPage({ children, className }: Props) {
  return (
    <div className={classNames('search-page', className)}>
      {children}
    </div>
  );
}
